export const EXAMPLE_BUSINESS_EMAIL = "support@brandA.com";

export const FOOTER_NOTE =
  "This overrides both the workspace default email and TrustChat fallback email.";

export function formatGroupLabel(group) {
  if (!group) return "";
  const email =
    group.raw?.group_email ||
    group.raw?.email ||
    group.raw?.support_email ||
    group.raw?.channels?.[0]?.channel_id ||
    "";
  return email ? `${group.name} - ${email}` : group.name;
}

export const EMAIL_HIERARCHY = [
  {
    title: "Group Business Email",
    description: "Configured on this page, highest priority",
  },
  {
    title: "Personal Linked Email",
    description: "Agent's personal company email (from Link Email settings)",
  },
  {
    title: "Workspace Default Email",
    description: "Set in workspace settings",
  },
  {
    title: "TrustChat Fallback",
    description: "Used when no other email is configured",
  },
];

export function getErrorMessage(payload) {
  if (!payload) return "Something went wrong";
  if (typeof payload === "string") return payload;
  return (
    payload.message ||
    payload.error ||
    (Array.isArray(payload.errors) && payload.errors[0]?.message) ||
    "Something went wrong"
  );
}
